import Carousel from '@/features/carousel/components/carousel';
import useSwipeable from '@/features/carousel/hooks/use-swipeable';

export * from './types';

export { useSwipeable };

export default Carousel;
